function buocDatLaiMatKhau() {
  return [
    {
      target: "body",
      placement: "center",
      title: "Bước 1 · Đặt lại mật khẩu",
      content:
        "Màn này gửi email chứa liên kết đặt mật khẩu mới. Bạn cần dùng đúng email tài khoản đã được cấp trong hệ thống.",
    },
    {
      target: "#tour-dat-lai-mat-khau-email",
      title: "Bước 2 · Nhập email",
      content:
        'Nhập email đăng nhập rồi bấm "Gửi liên kết đặt lại mật khẩu". Sau đó nhớ kiểm tra hộp thư, kể cả mục Spam/Thư rác — đây là lý do phổ biến nhất khiến người dùng tưởng tính năng bị hỏng dù email đã gửi thành công. Mở email, bấm liên kết, đặt mật khẩu mới rồi quay lại màn Đăng nhập.',
      placement: "bottom",
    },
  ];
}

export default buocDatLaiMatKhau;
